"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IUBODeclarationStatus = void 0;
var IUBODeclarationStatus;
(function (IUBODeclarationStatus) {
    IUBODeclarationStatus["CREATED"] = "CREATED";
    IUBODeclarationStatus["VALIDATED"] = "VALIDATED";
    IUBODeclarationStatus["REFUSED"] = "REFUSED";
    IUBODeclarationStatus["INCOMPLETE"] = "INCOMPLETE";
    IUBODeclarationStatus["VALIDATION_ASKED"] = "VALIDATION_ASKED";
})(IUBODeclarationStatus || (exports.IUBODeclarationStatus = IUBODeclarationStatus = {}));
//# sourceMappingURL=IUBODeclarationStatus.js.map